module.exports = __webpack_public_path__ + "static/media/messenger_help.ddb78d6d.svg";